// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ===== TasksGlobal Specific Styles ===== */
:root {
    /* Colors specific to Contracts logic */
    --section-border-our: #2196F3;   /* niebieski - OUR contracts */
    --section-border-other: #FF9800; /* pomarańczowy - OTHER contracts */
    --section-border-width: 4px;
}

/* Contract Typography */
.contract-id {
    font-size: var(--section-text-xs);
    font-weight: 700;
    color: var(--section-text-secondary);
    text-transform: uppercase;
    letter-spacing: 0.05em;
}

.contract-title {
    font-size: var(--section-text-lg);
    color: var(--section-text-primary);
    margin-bottom: 0;
}

.contract-status-badge {
    font-size: var(--section-text-10) !important;
}

/* L1 — HERO: alias · wykonawca (kotwica pamięciowa, element dominujący) */
.contract-hero {
    font-size: 1.3rem;
    font-weight: 700;
    color: var(--section-text-primary);
    line-height: 1.2;
}

/* Separator „·" między aliasem a wykonawcą — jasny i cienki (jak na makiecie B2-a),
   delikatnie oddziela kotwicę, nie dziedziczy pogrubienia hero. */
.contract-hero-sep {
    color: #c7ccd1;
    font-weight: 400;
}

/* L3 — zdegradowana nazwa kontraktu (drugi plan, bez pogrubienia).
   font-weight: 400 jawnie — inaczej dziedziczy bold z przycisku nagłówka akordeonu
   i nazwa wychodzi pogrubiona zamiast schodzić na drugi plan. */
.contract-name-demoted {
    font-size: var(--section-text-base); /* 1rem */
    font-weight: 400;
    color: #495057;
}

.contract-metadata {
    font-size: var(--section-text-sm);
    color: var(--section-text-secondary);
}

.contract-metadata-icon {
    font-size: 1.125rem;
    color: var(--section-text-muted);
}

.contract-metadata strong {
    color: var(--section-text-primary);
}

/* ===== Zadania (liście) — muszą być wizualnie PODRZĘDNE wobec Sprawy =====
   Sprawa to nagłówek sekcji poziomu 3 (font 1rem, lekki). Zadanie jest pod nią,
   więc nie może być wyraźniejsze: mniejszy tekst, gęściej, wcięcie + linia
   podrzędności. Kolumny zostają (porządkują widok). */
.task-leaf-row {
    font-size: var(--section-text-sm); /* 0.875rem < tytuł sprawy (1rem) */
    line-height: 1.25;
    padding: 0.1rem 0 0.1rem 1.5rem; /* gęsto + wcięcie pod sprawę */
    margin-left: 0.25rem;
    border-left: 2px solid #e9ecef; /* delikatne zakotwiczenie pod sprawą */
    color: var(--section-text-secondary);
}

.task-leaf-row .task-name {
    color: var(--section-text-primary); /* nazwa czytelna, ale bez pogrubienia */
}

.task-leaf-row .task-description {
    font-size: var(--section-text-xs);
    line-height: 1.15;
}
`, "",{"version":3,"sources":["webpack://./src/TasksGlobal/TasksGlobal.css"],"names":[],"mappings":"AAAA,4CAA4C;AAC5C;IACI,uCAAuC;IACvC,6BAA6B,IAAI,8BAA8B;IAC/D,+BAA+B,EAAE,mCAAmC;IACpE,2BAA2B;AAC/B;;AAEA,wBAAwB;AACxB;IACI,iCAAiC;IACjC,gBAAgB;IAChB,oCAAoC;IACpC,yBAAyB;IACzB,sBAAsB;AAC1B;;AAEA;IACI,iCAAiC;IACjC,kCAAkC;IAClC,gBAAgB;AACpB;;AAEA;IACI,4CAA4C;AAChD;;AAEA,0EAA0E;AAC1E;IACI,iBAAiB;IACjB,gBAAgB;IAChB,kCAAkC;IAClC,gBAAgB;AACpB;;AAEA;kEACkE;AAClE;IACI,cAAc;IACd,gBAAgB;AACpB;;AAEA;;gEAEgE;AAChE;IACI,mCAAmC,EAAE,SAAS;IAC9C,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,iCAAiC;IACjC,oCAAoC;AACxC;;AAEA;IACI,mBAAmB;IACnB,gCAAgC;AACpC;;AAEA;IACI,kCAAkC;AACtC;;AAEA;;;sDAGsD;AACtD;IACI,iCAAiC,EAAE,mCAAmC;IACtE,iBAAiB;IACjB,+BAA+B,EAAE,+BAA+B;IAChE,oBAAoB;IACpB,8BAA8B,EAAE,uCAAuC;IACvE,oCAAoC;AACxC;;AAEA;IACI,kCAAkC,EAAE,wCAAwC;AAChF;;AAEA;IACI,iCAAiC;IACjC,iBAAiB;AACrB","sourcesContent":["/* ===== TasksGlobal Specific Styles ===== */\n:root {\n    /* Colors specific to Contracts logic */\n    --section-border-our: #2196F3;   /* niebieski - OUR contracts */\n    --section-border-other: #FF9800; /* pomarańczowy - OTHER contracts */\n    --section-border-width: 4px;\n}\n\n/* Contract Typography */\n.contract-id {\n    font-size: var(--section-text-xs);\n    font-weight: 700;\n    color: var(--section-text-secondary);\n    text-transform: uppercase;\n    letter-spacing: 0.05em;\n}\n\n.contract-title {\n    font-size: var(--section-text-lg);\n    color: var(--section-text-primary);\n    margin-bottom: 0;\n}\n\n.contract-status-badge {\n    font-size: var(--section-text-10) !important;\n}\n\n/* L1 — HERO: alias · wykonawca (kotwica pamięciowa, element dominujący) */\n.contract-hero {\n    font-size: 1.3rem;\n    font-weight: 700;\n    color: var(--section-text-primary);\n    line-height: 1.2;\n}\n\n/* Separator „·\" między aliasem a wykonawcą — jasny i cienki (jak na makiecie B2-a),\n   delikatnie oddziela kotwicę, nie dziedziczy pogrubienia hero. */\n.contract-hero-sep {\n    color: #c7ccd1;\n    font-weight: 400;\n}\n\n/* L3 — zdegradowana nazwa kontraktu (drugi plan, bez pogrubienia).\n   font-weight: 400 jawnie — inaczej dziedziczy bold z przycisku nagłówka akordeonu\n   i nazwa wychodzi pogrubiona zamiast schodzić na drugi plan. */\n.contract-name-demoted {\n    font-size: var(--section-text-base); /* 1rem */\n    font-weight: 400;\n    color: #495057;\n}\n\n.contract-metadata {\n    font-size: var(--section-text-sm);\n    color: var(--section-text-secondary);\n}\n\n.contract-metadata-icon {\n    font-size: 1.125rem;\n    color: var(--section-text-muted);\n}\n\n.contract-metadata strong {\n    color: var(--section-text-primary);\n}\n\n/* ===== Zadania (liście) — muszą być wizualnie PODRZĘDNE wobec Sprawy =====\n   Sprawa to nagłówek sekcji poziomu 3 (font 1rem, lekki). Zadanie jest pod nią,\n   więc nie może być wyraźniejsze: mniejszy tekst, gęściej, wcięcie + linia\n   podrzędności. Kolumny zostają (porządkują widok). */\n.task-leaf-row {\n    font-size: var(--section-text-sm); /* 0.875rem < tytuł sprawy (1rem) */\n    line-height: 1.25;\n    padding: 0.1rem 0 0.1rem 1.5rem; /* gęsto + wcięcie pod sprawę */\n    margin-left: 0.25rem;\n    border-left: 2px solid #e9ecef; /* delikatne zakotwiczenie pod sprawą */\n    color: var(--section-text-secondary);\n}\n\n.task-leaf-row .task-name {\n    color: var(--section-text-primary); /* nazwa czytelna, ale bez pogrubienia */\n}\n\n.task-leaf-row .task-description {\n    font-size: var(--section-text-xs);\n    line-height: 1.15;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
